import React, { useEffect, useState } from "react";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Input,
  Textarea,
  Select,
  Spinner,
} from "@chakra-ui/react";

import support_dark_icon from "../../../assets/images/icons/support_dark_icon.png";
import check_icon from "../../../assets/images/icons/check_icon.png";
import cross_dark_icon from "../../../assets/images/icons/cross_dark_icon.png";

import GetSupportTicketTypeList from "services/GetSupportTicketTypeList";
import PostSupportTicket from "services/PostSupportTicket";
import ThemeColorConstant from "constants/ThemeColorsConstant";

export default function NewTicketModalHelpSupportComponent(props) {
  const { isOpen, onClose, setRefreshSupportTickets } = props;

  const [supportTypeList, setSupportTypeList] = useState([]);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const get_type_list = async () => {
      const res = await GetSupportTicketTypeList();

      setSupportTypeList(res.data);
    };

    get_type_list();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);

    try {
      setLoading(true);
      const res = await PostSupportTicket(formData);

      if (res.status === 200) {
        onClose();
        setRefreshSupportTickets((prev) => !prev);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }

    return;
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <div className="flex flex-row gap-2">
              <div className="h-6 w-6  flex flex-col justify-center ">
                <img src={support_dark_icon} />
              </div>

              <h4>New Support Ticket</h4>
            </div>
            <ModalCloseButton />
          </ModalHeader>

          <form onSubmit={(e) => handleSubmit(e)}>
            <ModalBody sx={{ padding: "2rem" }}>
              <div className="flex flex-col gap-5">
                <div>
                  <p className="label">Subject</p>
                  <Input
                    type="text"
                    name="support_ticket_title"
                    sx={{
                      border: "1px solid black",
                      height: "3.13rem",
                      padding: "0.5rem",
                    }}
                    placeholder=" "
                  />
                </div>
                <div>
                  <p className="label">Description</p>
                  <Textarea
                    name="support_ticket_description"
                    type="text"
                    placeholder=" "
                    sx={{
                      border: "1px solid black",
                      borderRadius: "0rem",
                      height: "6.25rem",
                      padding: "0.5rem",

                      _focus: {
                        border: `1px solid ${ThemeColorConstant.secondaryColor}`,
                      },
                    }}
                  />
                </div>
                <div>
                  <p className="label">Category</p>
                  <Select
                    name="support_ticket_type_id"
                    variant={"outlineCustom"}
                    sx={{
                      border: "1px solid black",
                      height: "3.13rem",
                      padding: "0.5rem",
                    }}
                  >
                    {supportTypeList.map((data) => {
                      return (
                        <option
                          key={data.support_ticket_type_id}
                          value={data.support_ticket_type_id}
                        >
                          {data.support_ticket_type_name}
                        </option>
                      );
                    })}
                  </Select>
                </div>

                {/* todo: attachment disabled for now */}
                {/* 
                <div className="">
                  <p className="label">Attachments</p>
                  <div className=" border-2 w-[32rem] h-[2.63rem] py-4 px-3 flex flex-col justify-center ">
                    <div className="  text-center ">
                      Upload Screenshots or files (if any)
                    </div>
                  </div>
                </div> */}
              </div>
            </ModalBody>

            <ModalFooter>
              <div className="flex flex-row justify-end gap-2">
                <div className="h-[3.13]">
                  <Button
                    sx={{ height: "3.13rem" }}
                    variant="ghost"
                    onClick={onClose}
                  >
                    <img className="mr-2" src={cross_dark_icon} /> Cancel
                  </Button>
                </div>

                <div className="w-[10rem] h-[3.13]">
                  <Button type="submit" isDisabled={loading}>
                    {!loading ? (
                      <>
                        <img
                          className="mr-2"
                          alt="Tick Icon"
                          src={check_icon}
                        />
                        Submit Ticket
                      </>
                    ) : (
                      <>
                        <Spinner size={"sm"} />
                      </>
                    )}
                  </Button>
                </div>
              </div>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
    </>
  );
}
